import styled from 'styled-components';
import photo from 'assets/images/photo-banner.jpg';
import { fonts } from 'styles';
export const Container = styled.header`
  width: 100%;
  max-width: 1920px;
  display: flex;
  margin-bottom: 96px;

  @media screen and (max-width: 1023px) {
    flex-direction: column;
    margin-bottom: 32px;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;

  &.right {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 1023px) {
    height: auto;

    &.right {
      padding: 40px;
    }
  }
`;

export const Photo = styled.img.attrs({ src: photo })`
  width: 100%;
  object-fit: cover;

  @media screen and (max-width: 1023px) {
    object-fit: contain;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBold};
  font-size: 70px;
  line-height: 70px;
  color: #000;
  margin-bottom: 32px;

  @media screen and (max-width: 500px) {
    font-size: 50px;
    line-height: 50px;
  }
`;

export const Text = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 18px;
  line-height: 26px;
  color: #000;
  max-width: 412px;
  margin-bottom: 32px;
  text-align: center;

  @media screen and (max-width: 500px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Credits = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 20px;
  color: #000;
  max-width: 412px;
  text-transform: uppercase;
  text-align: center;

  @media screen and (max-width: 500px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
